import { Breadcrumb, LogoMarquee } from '@/components'
import BottomBanner from './components/BottomBanner'
import CouponCategories from './components/CouponCategories'
import CouponRecommendations from './components/CouponRecommendations'
import HeroBanner from './components/HeroBanner'
import ServiceContent from './components/ServiceContent'
import ServiceFeatures from './components/ServiceFeatures'

const Coupon = () => (
  <div className="min-w-[1200px]">
    <HeroBanner />
    <Breadcrumb currentKey="coupon.breadcrumb.current" />
    <CouponRecommendations />
    <div className="pb-[96px] bg-[#FAFAFA]">
      <LogoMarquee />
    </div>
    <CouponCategories />
    <div className="bg-[#FAFAFA]">
      <ServiceContent />
    </div>
    <ServiceFeatures />
    <BottomBanner />
  </div>
)

export default Coupon
